<template>
	<div class="mainWrapper dp">
		<h1>Direct Purchase Detail</h1>
		<div class="dp-details" v-if="detail">
			<div class="first-row">
				<div class="details"><span>DIRECT PURCHASE NUMBER</span> <br />{{ detail.direct_purchase.code }}</div>

				<div class="details">
					<span>APPROVED BY</span> <br />
					{{ detail.direct_purchase.author.name }}
				</div>

				<div class="details">
					<span>CREATED</span> <br />
					{{ convertTime(detail.direct_purchase.createdAt) }}
				</div>
			</div>

			<div class="list">
				<div class="poItemList header">
					<div>BD CODE</div>
					<div>BARCODE</div>
					<div>PRODUCT NAME</div>
					<div>QUANTITY</div>
					<div>PRICE</div>
					<div>RECEIVED DATE</div>
					<div>REMARK</div>
					<div>FOC</div>
				</div>

				<div v-for="(item, index) of detail.direct_purchase_items" v-bind:key="index" class="poItemList">
					<div>{{ item.product.bd_code }}</div>
					<div>{{ item.product.barcode }}</div>
					<div>{{ item.product.name }}</div>
					<div>
						{{ item.qty }} <span class="packaging_selection">{{ item.packaging_selection ? item.packaging_selection : '' }}</span>
					</div>
					<div>{{ item.price }}</div>
					<div>{{ convertTime(item.received_date) }}</div>
					<div>{{ item.remark }}</div>
					<div>{{ item.foc === true ? 'YES' : '' }}</div>
				</div>
			</div>

			<div class="po-detail-buttons-wrapper">
				<div class="align-left">
					<b-button type="is-dark" icon-left="arrow-left" @click="back()">BACK</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PurchaseOrderDetails',
	data: function() {
		return {
			id: this.$route.params.id, //id from get url
			detail: null,
			piProducts: null
		}
	},
	mounted: async function() {
		// Get all the PI
		var data = {
			id: this.id,
			populate_direct_purchase: ['author'],
			populate_direct_purchase_item: ['product']
		}

		const apiGetPI = await this.$api.getDPDetail({ data })

		this.detail = apiGetPI.data

		console.log(this.detail)
	},
	methods: {
		back: function() {
			this.$router.push('/direct-purchase')
		},
		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY')
		}
	}
}
</script>

<style scoped>
@import '../styles/DPView.css';
</style>
